module.exports = __webpack_public_path__ + "static/media/A1_TELECOM_LOGO.278eaf8e.png";